import React, { Component } from "react";
import { CustomInput, Input } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import {
  addAttraction,
  attractionList,
  editAttraction,
  updateAttraction,
  removeAttraction,
} from "../../Endpoint/Admin/index";
import { toast } from "react-toastify";
import { ConsolePage } from "../../components/Console/ConsoleLayout";
import {
  C, Panel, Btn, SearchPill, ChipTabs, Thumb, Dialog, DialogHead, DialogBtn, ConfirmDialog, Field, Toggle,
} from "../../components/Console/ConsoleUI";
import { canWrite } from "../../services/PermissionService";
import BranchAssignment from "../../components/Common/BranchAssignment";

/**
 * Attractions catalogue — screen E?·"Web Attractions" of the console redesign
 * (web-attractions.html).
 *
 * An attraction is a photograph and a name, so the design shows a card grid
 * with the photograph large, and puts the one selected item in an inspector on
 * the right. The table it replaces showed a 50px thumbnail and two buttons.
 *
 * Re-skin only: addAttraction / updateAttraction still post the same multipart
 * FormData, and the list still comes from attractionList().
 */

const CSS = `
.attr-card{background:#fff;border:1px solid ${C.tint};border-radius:18px;overflow:hidden;
  display:flex;flex-direction:column;cursor:pointer;text-align:left;padding:0;font-family:inherit;
  transition:box-shadow .15s,border-color .15s}
.attr-card:hover{border-color:${C.sand};box-shadow:0 8px 22px rgba(61,40,23,.09)}
.attr-card.is-selected{border-color:${C.brown};box-shadow:0 8px 22px rgba(61,40,23,.14)}
.attr-act{border:0;background:transparent;padding:0;font-family:inherit;font-size:13px;
  font-weight:500;color:${C.brown};cursor:pointer;display:flex;align-items:center;gap:6px}
.attr-act:hover{text-decoration:underline}
.attr-act.is-danger{color:${C.red}}
.attr-modal .form-control,.attr-modal .custom-file-input{height:48px;padding:0 15px;background:#fff;
  border:1px solid #e6d8c4;border-radius:12px;font-size:15px;color:${C.ink};box-shadow:none}
.attr-modal .form-group{margin-bottom:0}
.attr-newtile{border:1px dashed #dfcdb2;border-radius:18px;display:flex;flex-direction:column;
  align-items:center;justify-content:center;gap:9px;color:${C.taupeLight};min-height:230px;
  cursor:pointer;background:transparent;font-family:inherit;font-size:14px;width:100%}
.attr-newtile:hover{border-color:${C.brown};color:${C.brown}}
`;

// Stored values for Attraction.category (the schema enum) and their labels.
const CATEGORIES = [
  { value: "on_site", label: "At the hotel" },
  { value: "nearby", label: "Nearby" },
];
const categoryLabel = (v) => (CATEGORIES.find((c) => c.value === v) || {}).label || "Nearby";

// isFree defaults to true on the schema, so only an explicit false is paid.
const priceLabel = (a) =>
  a.isFree === false ? (a.price != null ? `$${Number(a.price).toFixed(2)}` : "Paid") : "Free";

// Inside .attr-modal every .form-control is a 48px single line; a textarea
// needs its height back.
const TEXTAREA_STYLE = { height: "auto", padding: "12px 15px" };

const fmtDate = (d) =>
  d ? new Date(d).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" }) : "—";

class Attraction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      previewImage: undefined,
      items: [],
      isLoaded: false,
      modal: false,
      attractonName: "",
      selectedFile: null, // to store selected file
      handleResponse: null, // handle the API response
      invalidImage: null,
      selectedFileName: "",
      attractionId: null,
      // Detail fields. price is a string so the input can be blank.
      description: "",
      category: "nearby",
      isFree: true,
      price: "",
      hours: "",
      branchIds: [],
      excludedBranchIds: [],
      // Console shell state
      search: "",
      filter: "",
      selectedId: null,
      showDeleteModal: false,
      pendingDeleteId: null,
      actionLoading: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.onFileChange = this.onFileChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.toggle = this.toggle.bind(this);
    this.editAttraction = this.editAttraction.bind(this);
    this.removeAttraction = this.removeAttraction.bind(this);
    this.getALlluser = this.getALlluser.bind(this);
  }

  toggle() {
    this.setState({
      modal: !this.state.modal,
      attractonName: "",
      selectedFile: "",
      previewImage: "",
      invalidImage: "",
      attractionId: "",
      description: "",
      category: "nearby",
      isFree: true,
      price: "",
      hours: "",
      branchIds: [],
      excludedBranchIds: [],
    });
  }

  handleCloseModal() {
    this.setState({
      modal: false,
    });
  }

  onFileChange(event) {
    // Read the file off the event once and keep it. React 16 pools synthetic
    // events, so re-reading event.target further down logs a "released
    // synthetic event" warning — same behaviour, one fewer console error.
    const imageFile = event.target.files[0];
    if (!imageFile) return false;

    if (!imageFile.name.match(/\.(jpg|jpeg|png)$/)) {
      this.setState({
        invalidImage: "Please select valid image.",
        previewImage: URL.createObjectURL(imageFile),
      });
      return false;
    } else {
      this.setState({
        selectedFile: imageFile,
        previewImage: URL.createObjectURL(imageFile),
        invalidImage: null,
      });
    }
  }

  handleChange = (e) => {
    this.setState(
      {
        [e.target.id]: e.target.value,
      },
      () => {}
    );
  };

  handleSubmit() {
    // AvForm prevents the browser's default submit itself before calling this,
    // and by then React 16 has released the pooled event — the old
    // e.preventDefault() here only logged a "released synthetic event" warning.
    const { isFree } = this.state;
    const price = String(this.state.price == null ? "" : this.state.price).trim();
    if (!isFree) {
      if (price === "") {
        toast.error("Enter a price, or mark the attraction as free");
        return;
      }
      if (!Number.isFinite(Number(price)) || Number(price) < 0) {
        toast.error("Price must be a number of 0 or more");
        return;
      }
    }

    const formData = new FormData();
    formData.append("attractonName", this.state.attractonName);
    // Multipart strings, parsed by attractionDetails(): isFree is "true" /
    // "false", and price "" clears it — a free attraction carries no price.
    formData.append("description", this.state.description.trim());
    formData.append("category", this.state.category);
    formData.append("isFree", isFree ? "true" : "false");
    formData.append("price", isFree ? "" : price);
    formData.append("hours", this.state.hours.trim());
    // JSON arrays, as the catalog forms send them (parseBranchIds). The server
    // ignores both for a branch admin.
    formData.append("branchIds", JSON.stringify(this.state.branchIds || []));
    formData.append(
      "excludedBranchIds",
      JSON.stringify(this.state.excludedBranchIds || [])
    );

    formData.append("attractImage", this.state.selectedFile);
    formData.append("attractionId", this.state.attractionId);

    if (this.state.attractionId == "" || this.state.attractionId == null) {
      addAttraction(formData)
        .then((response) => {
          if (response.status !== 200) {
            toast.error(response.message, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else {
            this.setState({
              handleResponse: {
                isSuccess: response.status === 200,
                message: "success",
                featureName: "",
                selectedFile: null, // to store selected file
                handleResponse: null, // handle the API response
                imageUrl: null, // to store uploaded image path
                invalidImage: null,
                selectedFileName: "",
                previewImage: "",
                attractionId: "",
              },
            });
            this.getALlluser();

            this.handleCloseModal();

            toast.success("Attraction added successfully");
          }
        })
        .catch((error) => {
          toast.error("error");
        });
    } else {
      updateAttraction(formData)
        .then((updateResults) => {
          if (updateResults.status !== 200) {
            toast.error(updateResults.message, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else {
            this.setState({
              handleResponse: {
                isSuccess: updateResults.status === 200,
                message: "success",
                attractionId: "",
              },
            });
            this.getALlluser();

            this.handleCloseModal();

            toast.success("attracttion updated successfully");
          }
        })
        .catch((error) => {
          toast.error("error");
        });
    }
  }

  editAttraction(id) {
    editAttraction(id)
      .then((results) => {
        const d = results.data;
        this.setState({
          attractonName: d.attractonName,
          previewImage: d.image,
          selectedFile: d.imageFile,
          attractionId: d._id,
          description: d.description || "",
          category: d.category || "nearby",
          isFree: d.isFree !== false,
          price: d.price == null ? "" : String(d.price),
          hours: d.hours || "",
          branchIds: (d.branchIds || []).map((b) => (b && b._id ? b._id : String(b))),
          excludedBranchIds: (d.excludedBranchIds || []).map((b) =>
            b && b._id ? b._id : String(b)
          ),
        });
      })
      .catch((error) => {
        toast.error("error");
      });
    this.setState({ modal: true });
  }

  removeAttraction(id) {
    this.setState({ actionLoading: true });
    removeAttraction(id)
      .then((response) => {
        if (response.status !== 200) {
          toast.error(response.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        } else {
          toast.success(response.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          this.getALlluser();
        }
      })
      .catch((error) => {
        toast.error("error");
      })
      .finally(() => {
        this.setState({
          actionLoading: false,
          showDeleteModal: false,
          pendingDeleteId: null,
          selectedId: this.state.selectedId === id ? null : this.state.selectedId,
        });
      });
  }

  getALlluser() {
    attractionList().then((result) => {
      this.setState({
        isLoaded: true,
        items: result.data || [],
      });
    });
  }

  componentDidMount() {
    this.getALlluser();
  }

  askDelete = (id) => this.setState({ showDeleteModal: true, pendingDeleteId: id });

  toggleDeleteModal = () =>
    this.setState({ showDeleteModal: !this.state.showDeleteModal, pendingDeleteId: null });

  visibleItems() {
    const { items, search, filter } = this.state;
    const q = search.trim().toLowerCase();
    return (items || []).filter((a) => {
      if (filter === "live" && a.isActive === false) return false;
      if (filter === "hidden" && a.isActive !== false) return false;
      if (!q) return true;
      return (a.attractonName || "").toLowerCase().includes(q);
    });
  }

  renderCard(a) {
    const live = a.isActive !== false;
    const selected = this.state.selectedId === a._id;
    const write = canWrite();

    return (
      <button
        key={a._id}
        type="button"
        className={`attr-card${selected ? " is-selected" : ""}`}
        onClick={() => this.setState({ selectedId: a._id })}
      >
        <div style={{ position: "relative", height: 148, background: C.iconTint }}>
          <Thumb src={a.image} alt={a.attractonName} icon="attractions" height={148} />
          <span
            style={{
              position: "absolute", top: 12, left: 12, padding: "5px 11px", borderRadius: 10,
              fontSize: 12, fontWeight: 700, color: "#fff",
              background: live ? C.green : "rgba(43,32,24,.72)",
            }}
          >
            {live ? "LIVE" : "HIDDEN"}
          </span>
        </div>
        <div style={{ padding: "16px 18px", display: "flex", flexDirection: "column", flex: 1 }}>
          <div style={{ fontSize: 12, color: C.taupeLight, letterSpacing: ".6px", textTransform: "uppercase" }}>
            {categoryLabel(a.category)} · {priceLabel(a)}
          </div>
          <div style={{ marginTop: 4, fontSize: 17, fontWeight: 500, color: C.ink }}>
            {a.attractonName || "Untitled"}
          </div>
          <div style={{ marginTop: 8, fontSize: 13, color: C.taupe }}>
            Added {fmtDate(a.createdAt)}
          </div>

          {write && (
            <div
              style={{
                marginTop: 14, paddingTop: 12, borderTop: `1px solid ${C.panel}`,
                display: "flex", alignItems: "center", justifyContent: "space-between",
              }}
            >
              <span
                className="attr-act"
                onClick={(e) => {
                  e.stopPropagation();
                  this.editAttraction(a._id.toString());
                }}
              >
                Edit
                <span className="ms" style={{ fontSize: 17, color: C.taupeLight }}>edit</span>
              </span>
              <span
                className="attr-act is-danger"
                onClick={(e) => {
                  e.stopPropagation();
                  this.askDelete(a._id.toString());
                }}
              >
                <span className="ms" style={{ fontSize: 17 }}>delete</span>
              </span>
            </div>
          )}
        </div>
      </button>
    );
  }

  renderInspector() {
    const { items, selectedId } = this.state;
    const a = (items || []).find((x) => x._id === selectedId);
    const write = canWrite();

    if (!a) {
      return (
        <div>
          <div style={{ fontSize: 12, color: C.taupeLight, letterSpacing: ".6px" }}>SELECTED</div>
          <div style={{ marginTop: 14, fontSize: 14, color: C.taupe, lineHeight: 1.55 }}>
            Pick an attraction to see its details here.
          </div>
        </div>
      );
    }

    const live = a.isActive !== false;

    return (
      <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
        <div>
          <div style={{ fontSize: 12, color: C.taupeLight, letterSpacing: ".6px" }}>SELECTED</div>
          <div style={{ marginTop: 6, fontSize: 20, fontWeight: 500, color: C.brownDeep }}>
            {a.attractonName || "Untitled"}
          </div>
        </div>

        <div style={{ borderRadius: 16, overflow: "hidden", border: `1px solid ${C.tint}` }}>
          <Thumb src={a.image} alt={a.attractonName} icon="attractions" height={140} />
        </div>

        <Panel style={{ padding: 16, borderRadius: 16 }}>
          <div style={{ display: "flex", flexDirection: "column", gap: 12, fontSize: 14, color: C.slate }}>
            <div style={{ display: "flex", justifyContent: "space-between", gap: 12 }}>
              <span>Shown in app</span>
              <span style={{ fontWeight: 500, color: live ? "#2f7d33" : C.taupe }}>
                {live ? "Yes" : "No"}
              </span>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", gap: 12 }}>
              <span>Category</span>
              <span style={{ fontWeight: 500, color: C.ink }}>{categoryLabel(a.category)}</span>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", gap: 12 }}>
              <span>Price</span>
              <span style={{ fontWeight: 500, color: C.ink }}>{priceLabel(a)}</span>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", gap: 12 }}>
              <span>Hours</span>
              <span style={{ fontWeight: 500, color: a.hours ? C.ink : C.taupeLight, textAlign: "right" }}>
                {a.hours || "Not set"}
              </span>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", gap: 12 }}>
              <span>Added</span>
              <span style={{ fontWeight: 500, color: C.ink }}>{fmtDate(a.createdAt)}</span>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", gap: 12 }}>
              <span>Last updated</span>
              <span style={{ fontWeight: 500, color: C.ink }}>{fmtDate(a.updatedAt)}</span>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", gap: 12 }}>
              <span>Photo</span>
              <span style={{ fontWeight: 500, color: a.image ? C.ink : C.taupeLight }}>
                {a.image ? "Uploaded" : "None yet"}
              </span>
            </div>
          </div>
        </Panel>

        {a.description && (
          <div style={{ fontSize: 14, color: C.slate, lineHeight: 1.55, whiteSpace: "pre-line" }}>
            {a.description}
          </div>
        )}

        {write && (
          <div style={{ marginTop: "auto", display: "flex", flexDirection: "column", gap: 10 }}>
            <Btn
              icon="edit"
              onClick={() => this.editAttraction(a._id.toString())}
              style={{ width: "100%", height: 48 }}
            >
              Edit attraction
            </Btn>
            <Btn
              kind="quiet"
              icon="delete"
              onClick={() => this.askDelete(a._id.toString())}
              style={{ width: "100%", height: 48, color: C.red }}
            >
              Remove
            </Btn>
          </div>
        )}
      </div>
    );
  }

  renderModal() {
    const { handleResponse, invalidImage, previewImage, attractionId } = this.state;
    const editing = !!attractionId;

    return (
      <Dialog isOpen={this.state.modal} toggle={this.toggle} size="lg">
        <div className="attr-modal">
          <DialogHead
            title={editing ? "Edit attraction" : "Add attraction"}
            subtitle={
              editing
                ? "Changes reach the guest app as soon as you save"
                : "New attractions appear in the guest app once saved"
            }
            onClose={this.toggle}
          />

          <AvForm onValidSubmit={this.handleSubmit}>
            <div style={{ marginTop: 22, display: "flex", gap: 16, alignItems: "flex-start" }}>
              {/* The real file input stays exactly as it was — hidden, driven by
                  the label below, so validation and the change handler are
                  untouched. */}
              <div style={{ display: "none" }}>
                <AvField
                  tag={CustomInput}
                  name="file"
                  id="file"
                  type="file"
                  accept="image/*"
                  onChange={this.onFileChange}
                />
              </div>
              <label
                htmlFor="file"
                style={{
                  width: 132, height: 132, borderRadius: 16, border: "1.5px dashed #d9c3a5",
                  background: "#fff", display: "flex", flexDirection: "column",
                  alignItems: "center", justifyContent: "center", gap: 8,
                  color: C.taupeLight, cursor: "pointer", margin: 0,
                  flex: "0 0 132px", overflow: "hidden",
                }}
              >
                {previewImage ? (
                  <Thumb src={previewImage} alt="Selected attraction" icon="attractions" height={132} width={132} />
                ) : (
                  <React.Fragment>
                    <span className="ms" style={{ fontSize: 26 }}>add_photo_alternate</span>
                    <span style={{ fontSize: 12 }}>Upload photo</span>
                  </React.Fragment>
                )}
              </label>

              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 12, letterSpacing: ".6px", textTransform: "uppercase", color: C.taupe, marginBottom: 6 }}>
                  Attraction name
                </div>
                <AvField
                  type="text"
                  value={this.state.attractonName}
                  onChange={this.handleChange}
                  id="attractonName"
                  name="attractonName"
                  placeholder="e.g. Lubumbashi Zoo"
                  required
                                  errorMessage="Attraction name is required"
                                />
                <div style={{ marginTop: 8, fontSize: 12, color: C.taupeLight }}>
                  JPG or PNG. The photo is what guests see first.
                </div>
              </div>
            </div>

            {invalidImage && (
              <p style={{ marginTop: 12, marginBottom: 0, color: C.red, fontSize: 13 }}>{invalidImage}</p>
            )}

            <div style={{ marginTop: 18 }}>
              <Field label="Description">
                <Input
                  type="textarea"
                  id="description"
                  rows={3}
                  value={this.state.description}
                  onChange={this.handleChange}
                  placeholder="What guests will find there"
                  style={TEXTAREA_STYLE}
                />
              </Field>
            </div>

            <div style={{ marginTop: 14, display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}>
              <Field label="Category">
                <Input type="select" id="category" value={this.state.category} onChange={this.handleChange}>
                  {CATEGORIES.map((c) => (
                    <option key={c.value} value={c.value}>{c.label}</option>
                  ))}
                </Input>
              </Field>
              <Field label="Opening hours" hint="Free text, e.g. Daily 09:00-18:00">
                <Input
                  type="text"
                  id="hours"
                  value={this.state.hours}
                  onChange={this.handleChange}
                  placeholder="Daily 09:00-18:00"
                />
              </Field>
            </div>

            <div style={{ marginTop: 14, display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14, alignItems: "end" }}>
              <Field label="Admission">
                <div style={{ height: 48, display: "flex", alignItems: "center", gap: 12 }}>
                  <Toggle
                    on={this.state.isFree}
                    title="Free entry"
                    onClick={() => this.setState({ isFree: !this.state.isFree })}
                  />
                  <span style={{ fontSize: 14, color: C.slate }}>
                    {this.state.isFree ? "Free entry" : "Paid entry"}
                  </span>
                </div>
              </Field>
              {/* A free attraction has no price; it is cleared on save. */}
              {!this.state.isFree && (
                <Field label="Price ($) *">
                  <Input
                    type="number"
                    id="price"
                    min="0"
                    step="0.01"
                    value={this.state.price}
                    onChange={this.handleChange}
                    placeholder="0.00"
                  />
                </Field>
              )}
            </div>

            <div style={{ marginTop: 18 }}>
              <BranchAssignment
                branchIds={this.state.branchIds}
                excludedBranchIds={this.state.excludedBranchIds}
                overrides={[]}
                priceFields={[]}
                onChange={({ branchIds, excludedBranchIds }) =>
                  this.setState({ branchIds, excludedBranchIds })
                }
              />
            </div>
            {this.state.selectedFileName && (
              <p style={{ marginTop: 8, marginBottom: 0, fontSize: 13, color: C.taupe }}>
                {this.state.selectedFileName}
              </p>
            )}
            {handleResponse && (
              <p
                style={{
                  marginTop: 12, marginBottom: 0, fontSize: 13,
                  color: handleResponse.isSuccess ? C.green : C.red,
                }}
              >
                {handleResponse.message}
              </p>
            )}

            <div style={{ marginTop: 24, display: "flex", gap: 12 }}>
              <DialogBtn onClick={this.toggle}>Cancel</DialogBtn>
              <DialogBtn kind="primary" type="submit">
                {editing ? "Save changes" : "Add attraction"}
              </DialogBtn>
            </div>
          </AvForm>
        </div>
      </Dialog>
    );
  }

  render() {
    const { items, isLoaded, search, filter } = this.state;
    const write = canWrite();
    const visible = this.visibleItems();
    const liveCount = (items || []).filter((a) => a.isActive !== false).length;
    const pending = (items || []).find((a) => a._id === this.state.pendingDeleteId);

    return (
      <ConsolePage
        title="Attractions catalogue"
        subtitle={
          isLoaded
            ? `Experiences / Attractions · ${(items || []).length} listed`
            : "Loading attractions…"
        }
        actions={
          <React.Fragment>
            <SearchPill
              value={search}
              onChange={(v) => this.setState({ search: v })}
              placeholder="Search attractions"
              width={220}
            />
            {write && (
              <Btn icon="add" onClick={this.toggle}>
                New attraction
              </Btn>
            )}
          </React.Fragment>
        }
      >
        <style dangerouslySetInnerHTML={{ __html: CSS }} />

        <div style={{ display: "grid", gridTemplateColumns: "minmax(0,1fr) 320px", gap: 24, alignItems: "start" }}>
          <div style={{ display: "flex", flexDirection: "column", gap: 18, minWidth: 0 }}>
            <ChipTabs
              value={filter}
              onChange={(v) => this.setState({ filter: v })}
              options={[
                { value: "", label: "All", count: (items || []).length },
                { value: "live", label: "Live", count: liveCount },
                { value: "hidden", label: "Hidden", count: (items || []).length - liveCount },
              ]}
            />

            {!isLoaded ? (
              <div style={{ padding: "60px 0", textAlign: "center", color: C.taupeLight }}>
                Loading attractions…
              </div>
            ) : (
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, minmax(230px, 1fr))",
                  gap: 18,
                }}
              >
                {visible.map((a) => this.renderCard(a))}

                {write && (
                  <button type="button" className="attr-newtile" onClick={this.toggle}>
                    <span className="ms" style={{ fontSize: 26 }}>add_photo_alternate</span>
                    <span>Add an attraction</span>
                  </button>
                )}

                {visible.length === 0 && !write && (
                  <div style={{ padding: "60px 0", color: C.taupeLight }}>
                    No attractions match this filter.
                  </div>
                )}
              </div>
            )}
          </div>

          <div
            style={{
              padding: 22, borderRadius: 18, background: C.surfaceAlt,
              border: `1px solid ${C.border}`, position: "sticky", top: 100,
              display: "flex", flexDirection: "column", minHeight: 320,
            }}
          >
            {this.renderInspector()}
          </div>
        </div>

        {this.renderModal()}

        <ConfirmDialog
          isOpen={this.state.showDeleteModal}
          toggle={this.toggleDeleteModal}
          onConfirm={() => this.removeAttraction(this.state.pendingDeleteId)}
          icon="delete"
          title={`Remove ${pending ? pending.attractonName : "this attraction"}?`}
          body="It disappears from the guest app's attractions list straight away."
          tip="Deleting cannot be undone — you would have to add the attraction and its photo again."
          confirmText="Remove"
          loading={this.state.actionLoading}
        />
      </ConsolePage>
    );
  }
}

export default Attraction;
